import { loginApi } from './api';

import { post, Put } from '@/axiosConfig/index.js';
import { getCurrentUtmParams } from '@/utils/utm';

export default {
  register(params) {
    return post(loginApi.register, params);
  },
  checkAccount(params, hideMessageModal = false) {
    return post(loginApi.checkAccount, params, {
      hideMessageModal,
    });
  },
  sendEmailCode(params, hideMessageModal = false) {
    return post(loginApi.sendEmailCode, params, {
      hideMessageModal,
    });
  },
  loginEmailCode(params) {
    return post(loginApi.loginEmailCode, params);
  },
  checkEmailCode(params) {
    return post(loginApi.checkEmailCode, params, {
      hideMessageModal: true,
    });
  },
  signIn(params) {
    return post(loginApi.signIn, params);
  },
  resetPassword(params) {
    return Put(loginApi.resetPassword, params);
  },
  SignOut(params) {
    return post(loginApi.SignOut, params);
  },
  fogotPassword(params) {
    return post(loginApi.fogotPassword, params);
  },
  verificationLogin(params) {
    return post(loginApi.verificationLogin, params);
  },
  // Google OAuth methods
  initiateGoogleAuth() {
    // Get current UTM parameters
    const utmParams = getCurrentUtmParams();

    // Build the auth URL with UTM parameters if they exist
    let authUrl = loginApi.googleAuth;

    if (Object.keys(utmParams).length > 0) {
      const urlParams = new URLSearchParams();

      // Add UTM parameters to the URL
      Object.entries(utmParams).forEach(([key, value]) => {
        if (value) {
          urlParams.append(key, value);
        }
      });

      // Append parameters to the auth URL
      authUrl += (authUrl.includes('?') ? '&' : '?') + urlParams.toString();
    }

    window.location.href = authUrl;
    return Promise.resolve();
  },
  // This method can be used if you need to handle the callback programmatically
  handleGoogleCallback(params) {
    return post(loginApi.googleCallback, params);
  },
  // Direct token authentication
  handleTokenCallback(token) {
    // This is mainly handled by the tokenCallback component
    // But we can add this method for programmatic access
    return Promise.resolve();
  },
};
